"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var common_hooks_1 = require("@l2p/common-hooks");
var TimeLeft = function (_a) {
    var date = _a.date;
    var t = (0, next_intl_1.useTranslations)('lottery');
    var tDef = (0, next_intl_1.useTranslations)();
    var time = (0, common_hooks_1.useTimer)({ endDate: date }).time;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, t('timeLeft')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.timer }, "".concat(time.days).concat(tDef('timer.days'), " : ").concat(time.hours).concat(tDef('timer.hours'), " : ").concat(time.minutes).concat(tDef('timer.minutes')))));
};
exports.default = TimeLeft;
